export default function SectionWrapper({ id, children }) {
  return (
    <section id={id} className="py-5">
      <div className="container">{children}</div>
    </section>
  );
}
